import React from 'react';

const AddChildLinkModal = ({ 
  currentFolder,
  newChildLink, 
  setNewChildLink, 
  onAddChildLink, 
  onClose, 
  openIconSelector 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9000]">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">Adaugă Link în Folder: {currentFolder?.title}</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Platformă</label>
          <select
            name="platform"
            value={newChildLink.platform}
            onChange={(e) => setNewChildLink({...newChildLink, platform: e.target.value})}
            className="w-full p-2 border rounded"
          >
            <option value="">Selectează platformă</option>
            <option value="facebook">Facebook</option>
            <option value="twitter">Twitter</option>
            <option value="instagram">Instagram</option>
            <option value="linkedin">LinkedIn</option>
            <option value="youtube">YouTube</option>
            <option value="tiktok">TikTok</option>
            <option value="website">Website</option>
            <option value="email">Email</option>
            <option value="phone">Telefon</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="telegram">Telegram</option>
            <option value="globe">Link Universal</option>
          </select>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Titlu</label>
          <input
            type="text"
            name="title"
            value={newChildLink.title}
            onChange={(e) => setNewChildLink({...newChildLink, title: e.target.value})}
            className="w-full p-2 border rounded"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">URL</label>
          <input
            type="text"
            name="url"
            value={newChildLink.url}
            onChange={(e) => setNewChildLink({...newChildLink, url: e.target.value})}
            className="w-full p-2 border rounded"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Icon</label>
          <div className="flex space-x-2">
            <input
              type="text"
              name="icon"
              value={newChildLink.icon || ''}
              onChange={(e) => setNewChildLink({...newChildLink, icon: e.target.value})}
              className="flex-1 p-2 border rounded"
            />
            <button
              type="button"
              onClick={() => openIconSelector('newChildLink')}
              className="bg-blue-100 text-blue-700 px-3 py-2 rounded hover:bg-blue-200"
            >
              <i className="fa-solid fa-icons"></i> Alege
            </button>
          </div>
          {newChildLink.icon && (
            <div className="mt-2 p-2 border rounded flex items-center">
              <i className={`${newChildLink.icon} text-xl mr-2`}></i>
              <span className="text-sm text-gray-600">Preview iconiță</span>
            </div>
          )}
        </div>
        
        <div className="flex justify-end mt-6">
          <button 
            onClick={onClose}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2 hover:bg-gray-400"
          >
            Anulează
          </button>
          <button 
            onClick={onAddChildLink}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Adaugă Link
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddChildLinkModal; 